import React from 'react';

import { createIcon } from '@chakra-ui/react';

export const ExternalLinkIcon = createIcon({
  viewBox: '0 0 16 16',
  path: (
    <path
      clipRule="evenodd"
      d="M1.3335 3.3335C1.3335 2.22893 2.22893 1.3335 3.3335 1.3335H7.3335C7.70169 1.3335 8.00016 1.63197 8.00016 2.00016C8.00016 2.36835 7.70169 2.66683 7.3335 2.66683H3.3335C2.96531 2.66683 2.66683 2.96531 2.66683 3.3335V12.6668C2.66683 13.035 2.96531 13.3335 3.3335 13.3335H12.6668C13.035 13.3335 13.3335 13.035 13.3335 12.6668V8.66683C13.3335 8.29864 13.632 8.00016 14.0002 8.00016C14.3684 8.00016 14.6668 8.29864 14.6668 8.66683V12.6668C14.6668 13.7714 13.7714 14.6668 12.6668 14.6668H3.3335C2.22893 14.6668 1.3335 13.7714 1.3335 12.6668V3.3335ZM10.0002 2.66683C9.63197 2.66683 9.3335 2.36835 9.3335 2.00016C9.3335 1.63197 9.63197 1.3335 10.0002 1.3335H14.0002C14.3684 1.3335 14.6668 1.63197 14.6668 2.00016V6.00016C14.6668 6.36835 14.3684 6.66683 14.0002 6.66683C13.632 6.66683 13.3335 6.36835 13.3335 6.00016V3.60964L8.47157 8.47157C8.21122 8.73192 7.78911 8.73192 7.52876 8.47157C7.26841 8.21122 7.26841 7.78911 7.52876 7.52876L12.3907 2.66683H10.0002Z"
      fill="black"
      fillRule="evenodd"
    />
  ),
});
